import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { UserpilotReloader } from '../userpilot-reloader.component';

@Component({
  selector: 'custom-snackbar',
  templateUrl: 'custom-snackbar.component.html',
})

export class CustomSnackbarComponent extends UserpilotReloader {
  constructor(@Inject(MAT_SNACK_BAR_DATA) public data: { message: string, id?: string }) {
    super();
  }
}
